import { http } from ".";

export interface Product {
  id: string;
  revenue_cat_product_id: string;
  display_name: string;
  style_credits: number;
  image_credits: number;
  tier: "FREE" | "LITE" | "BASIC" | "PRO";
  renewable_type: "MONTHLY" | "YEARLY" | "NONRENEWABLE";
  stripe_price_id?: string; // Add this field
  price?: string; // Add pricing display field
  discount?: { savings: number; discountPercentage: number } | null; // Add discount field
}

export async function fetchProducts() {
  return http.get<Product[]>("/products/");
} 